import styled from 'styled-components'

import theme from '~/truck/theme'

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  margin-top: ${theme.spacing.comfortable}px;
`
